import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

const Panel = ({
  alert, children, error, info, success, className,
}) => {
  const classes = useMemo(() => cns(
    'panel', {
      'panel--success': success,
      'panel--error': error,
      'panel--info': info,
      'panel--alert': alert,
    },
    className,
  ), [success, error, info, alert, className]);

  return (
    <div className={classes}>
      <div className="panel__text">
        {children}
      </div>
    </div>
  );
};

Panel.propTypes = {
  /** Indica se mostrare un pannello con lo stile di alert */
  alert: PropTypes.bool,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se mostrare un pannello con lo stile di errore */
  error: PropTypes.bool,
  /** Indica se mostrare un pannello con lo stile di info */
  info: PropTypes.bool,
  /** Indica se mostrare un pannello con lo stile di successo */
  success: PropTypes.bool,
};

Panel.defaultProps = {
  alert: false,
  children: null,
  className: '',
  error: false,
  info: false,
  success: false,
};

export default Panel;
